<template>
    <div class="bidding_amount flex flex_center">
        <div class="close_box margin_r">
            <span class="close_icon" @click="clear">x</span>
        </div>
        <div class="flex_1 margin_r">
            <md-field class="bid_input">
                <label>{{$t("investor.exchange.table.operation.bid")}}</label>
                <MoneyAmountInput v-model="params.data[params.colDef.field]"></MoneyAmountInput>
            </md-field>
        </div>
    </div>
</template>

<script>
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput";

export default {
    components: {
        MoneyAmountInput
    },
    methods: {
        clear() {
            this.params.data[this.params.colDef.field] = null;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "src/components/templates/investor/exchange/bidInput.scss";
</style>
